import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { MODULES, hasModuleAccess, IN_APP_CHAT_ENABLED } from '../../config/modules';

/**
 * Smart redirect component for the home route "/"
 * Redirects users to the appropriate page based on their permissions
 */
const HomeRedirect = ({ children }) => {
  const { permissions, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: 'background.default'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If user has dashboard permission, show the dashboard
  if (hasModuleAccess(permissions, MODULES.DASHBOARD)) {
    return children;
  }

  // Otherwise, redirect to the first module they have access to
  const moduleRoutes = [
    { module: MODULES.CALL_CENTRE, path: '/call-centre' },
    { module: MODULES.BRANDS, path: '/brands' },
    { module: MODULES.CONNECTORS, path: '/connectors' },
    ...(IN_APP_CHAT_ENABLED ? [{ module: MODULES.CHAT, path: '/chat' }] : []),
    { module: MODULES.INVENTORY, path: '/inventory' },
    { module: MODULES.PROCUREMENT, path: '/procurement' },
    { module: MODULES.RETAIL, path: '/retail' },
    { module: MODULES.FINANCE, path: '/finance' },
    { module: MODULES.VISUALIZATIONS, path: '/visualizations' },
  ];

  for (const { module, path } of moduleRoutes) {
    if (hasModuleAccess(permissions, module)) {
      return <Navigate to={path} replace />;
    }
  }

  // If no permissions at all, show a message or redirect to profile
  return <Navigate to="/profile" replace />;
};

export default HomeRedirect;
